import {
  COW_FILTERS_RESET_ALL,
  // COW_FILTERS_SET_LOCATION,
  // COW_FILTERS_SET_DISTANCE,
  COW_FILTERS_SET_MIN_PRICE,
  COW_FILTERS_SET_MAX_PRICE,
  COW_FILTERS_SET_MIN_AGE,
  COW_FILTERS_SET_MAX_AGE,
  COW_FILTERS_SET_ATTRIBUTES,
  COW_FILTERS_SET_BREEDS,
  COW_FILTERS_SET_TYPE,
  COW_FILTERS_SET_VISIBLE,
  COW_FILTERS_SET_FAVOURITED,
  COW_FILTERS_SET_INTERESTED,
  COW_FILTERS_SET_MIN_SCORE,
  COW_FILTERS_SET_MAX_SCORE,
  COW_FILTERS_SET_SEARCH } from './constants';
import { createSelector } from 'reselect';
import { cowTypes } from '../cows/util/cowTypes';
import {
  getCows,
  getSortAttribute,
  getCowPage,
  getCowPageSize
} from '../cows/reducer';

export const initialState = {
  minScore: 0,
  maxScore: 120,
  minPrice: null,
  maxPrice: null,
  minAge: null,
  maxAge: null,
  location: null,
  maxDistance: 2000,
  attributes: [],
  cowType: 'YoungBulls',
  breeds: ['Aberdeen Angus', 'Stabiliser', 'South Devon'],
  sidebarVisible: false,
  favourited: false,
  interested: false,
  search: null
};

const now = new Date().toISOString();

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case COW_FILTERS_RESET_ALL:
      return { ...state, ...JSON.parse(JSON.stringify(initialState)) };
    // case COW_FILTERS_SET_LOCATION:
    //   return { ...state, location: action.location };
    // case COW_FILTERS_SET_DISTANCE:
    //   return { ...state, maxDistance: action.distance };
    case COW_FILTERS_SET_MIN_PRICE:
      return { ...state, minPrice: action.min };
    case COW_FILTERS_SET_MAX_PRICE:
      return { ...state, maxPrice: action.max };
    case COW_FILTERS_SET_MIN_AGE:
      return { ...state, minAge: action.min };
    case COW_FILTERS_SET_MAX_AGE:
      return { ...state, maxAge: action.max };
    case COW_FILTERS_SET_ATTRIBUTES:
      return { ...state, attributes: action.attributes };
    case COW_FILTERS_SET_BREEDS:
      return { ...state, breeds: action.breeds };
    case COW_FILTERS_SET_TYPE:
      return {
        ...state,
        ...JSON.parse(JSON.stringify(initialState)),
        cowType: action.cowType
      };
    case COW_FILTERS_SET_VISIBLE:
      return { ...state, sidebarVisible: action.visible };
    case COW_FILTERS_SET_FAVOURITED:
      return { ...state, favourited: action.isFavourited };
    case COW_FILTERS_SET_INTERESTED:
      return { ...state, interested: action.isInterested };
    case COW_FILTERS_SET_MIN_SCORE:
      return { ...state, minScore: action.score };
    case COW_FILTERS_SET_MAX_SCORE:
      return { ...state, maxScore: action.score };
    case COW_FILTERS_SET_SEARCH:
      return { ...state, search: action.search };
  }
  return state;
};

export const sortOptions = [
  'GoodBeef Index',
  'Price Highest',
  'Price lowest',
  // 'distance',
  'Age Oldest',
  'Age Youngest',
  'Recommended'
];

export const sortFunctions = {
  'Recommended': (a, b) => {
    // Primary sort put sold animals to the end of the list
    if (a.availabilityStatus === 'SOLD') {
      if (b.availabilityStatus !== 'SOLD') {
        return 1;
      }
    } else if (a.availabilityStatus === 'RESERVED') {
      if (b.availabilityStatus === 'SOLD') {
        return -1;
      } else if (b.availabilityStatus === 'AVAILABLE' ||
        typeof b.availabilityStatus === 'undefined') {
        return 1;
      }
    } else if (a.availabilityStatus === 'AVAILABLE' ||
      typeof a.availabilityStatus === 'undefined') {
      if (b.availabilityStatus !== 'AVAILABLE' &&
        typeof b.availabilityStatus !== 'undefined') {
        return -1;
      }
    }
    // Next up, sort by availability date
    if (a.availableDate && a.availableDate > now) {
      if (typeof b.availableDate === 'undefined') {
        return 1;
      } else if (a.availableDate > b.availableDate) {
        return 1;
      } else if (a.availableDate < b.availableDate) {
        return -1;
      }
    } else if (b.availableDate && b.availableDate > now) {
      return -1;
    }
    // Lastly sort by GBI
    if (a.beefQualityIndex === b.beefQualityIndex) return 0;
    return a.beefQualityIndex > b.beefQualityIndex ? -1 : 1;
  },
  // 'distance': (a, b) => {
  //   return a.age > b.age;
  // },
  'Age Oldest': (a, b) => {
    if (a.age === b.age) return 0;
    return a.age > b.age ? -1 : 1;
  },
  'Age Youngest': (a, b) => {
    if (a.age === b.age) return 0;
    return a.age < b.age ? -1 : 1;
  },
  'Price Highest': (a, b) => {
    if (a.price === b.price) return 0;
    return a.price > b.price ? -1 : 1;
  },
  'Price lowest': (a, b) => {
    if (a.price === b.price) return 0;
    return a.price < b.price ? -1 : 1;
  },
  'GoodBeef Index': (a, b) => {
    if (a.beefQualityIndex === b.beefQualityIndex) return 0;
    return a.beefQualityIndex > b.beefQualityIndex ? -1 : 1;
  }
};

export const finishedCattleSortFunctions = { ...sortFunctions };
finishedCattleSortFunctions['Price Highest'] = (a, b) => {
  if (a.pricePerKilo === b.pricePerKilo) return 0;
  return a.pricePerKilo > b.pricePerKilo ? -1 : 1;
};
finishedCattleSortFunctions['Price lowest'] = (a, b) => {
  if (a.pricePerKilo === b.pricePerKilo) return 0;
  return a.pricePerKilo < b.pricePerKilo ? -1 : 1;
};

const minScore = state => state.cowFilter.minScore;
const maxScore = state => state.cowFilter.maxScore;
const minPrice = state => state.cowFilter.minPrice;
const maxPrice = state => state.cowFilter.maxPrice;
const minAge = state => state.cowFilter.minAge;
const maxAge = state => state.cowFilter.maxAge;
// const location = state => state.cowFilter.location;
// const maxDistance = state => state.cowFilter.maxDistance;
const attributes = state => state.cowFilter.attributes;
const breeds = state => state.cowFilter.breeds;
const cowType = state => state.cowFilter.cowType;
const sidebarVisible = state => state.cowFilter.sidebarVisible;
const favourited = state => state.cowFilter.favourited;
const interested = state => state.cowFilter.interested;
const search = state => state.cowFilter.search;

// export const getLocation = createSelector(
//   location, location => location
// );
// export const getMaxDistance = createSelector(
//   maxDistance, maxDistance => maxDistance
// );
export const getSearchFilter = createSelector(search, search => search);
export const isFavourited = createSelector(
  [getCows, favourited], (cows, favourited) => {
    if (favourited !== true) return false;
    for (let i = 0; i < cows.length; i++) {
      if (cows[i].favourite) return true;
    }
    return false;
  }
);
export const isInterested = createSelector(
  [getCows, interested], (cows, interested) => {
    if (interested !== true) return false;
    for (let i = 0; i < cows.length; i++) {
      if (cows[i].interestRegistered) return true;
    }
    return false;
  }
);
export const getAttributes = createSelector(
  attributes, attributes => attributes
);
export const getBreeds = createSelector(
  breeds, breeds => breeds
);
export const getCowType = createSelector(
  cowType, type => type
);
export const getCowTypeText = createSelector(
  cowType, type => cowTypes[type] || ''
);
export const isSidebarVisible = createSelector(
  sidebarVisible, visible => visible
);

export const getCowsMatchingType = createSelector(
  [getCows, getCowType], (cows, type) => {
    const result = cows.filter(cow => cow.type === type);
    // console.log('cowsMatchingType length', result.length);
    return result;
  }
);
export const getCowsMatchingSearch = createSelector(
  [getCowsMatchingType, search], (cows, search) => {
    if (!search || typeof search !== 'string') return cows;
    const lowerSearch = search.toLowerCase();
    const trimmedSearch = lowerSearch.replace(/ /g, '');
    return cows.filter(cow => {
      if (cow.tag && typeof cow.tag === 'string') {
        const tag = cow.tag.replace(/ /g, '').toLowerCase();
        if (tag.includes(lowerSearch) || tag.includes(trimmedSearch)) {
          return true;
        }
      }
      if (cow.name && typeof cow.name === 'string') {
        const name = cow.name.toLowerCase();
        if (name.includes(lowerSearch)) return true;
      }
      return false;
    });
  }
);
export const cowsMatchingScore = createSelector(
  [getCowsMatchingSearch, minScore, maxScore],
  (cows, minScore, maxScore) => {
    const filteredCows = cows.filter(
      cow => {
        return (cow.beefQualityIndex >= minScore &&
          cow.beefQualityIndex <= (maxScore || 120));
      }
    );
    // console.log('cowsMatchingScore', filteredCows.length);
    return filteredCows;
  }
);
export const cowsMatchingAge = createSelector(
  [cowsMatchingScore, maxAge, minAge],
  (cows, maxAge, minAge) => {
    const result = cows.filter(cow => {
      return (cow.age >= minAge && cow.age <= (maxAge || 300));
    });
    // console.log('cowsMatchingAge', result.length);
    return result;
  }
);
export const cowsMatchingPrice = createSelector(
  [cowsMatchingAge, maxPrice, minPrice],
  (cows, maxPrice, minPrice) => {
    let min = (minPrice || 0) * 100; // price filters are in pounds - prices are in pennies
    let max = (maxPrice || 20000) * 100; // price filters are in pounds - prices are in pennies
    const result = cows.filter(cow => {
      const price = cow.type === 'FinishedCattle' ?
        cow.pricePerKilo : cow.price;
      const result = (price >= (min) && price <= (max));
      // console.log(`${cow.name} is ${result ? '' : 'not'} within price range`);
      return result;
    });
    // console.log('cowsMatchingPrice', result.length);
    return result;
  }
);
export const cowsMatchingAttributes = createSelector(
  [cowsMatchingPrice, attributes], (cows, attributes) => {
    const filteredCows = cows.filter(cow => {
      if (attributes.length === 0) return true;
      for (let i = 0; i < attributes.length; i++) {
        if (cow.documents && cow.documents[attributes[i]]) return true;
      }
      return false;
    });
    // console.log('cowsMatchingAttributes', filteredCows.length);
    return filteredCows;
  }
);
export const cowsMatchingBreed = createSelector(
  [cowsMatchingAttributes, breeds], (cows, breeds) => {
    const filteredCows = cows.filter(cow => {
      const result = breeds.includes(cow.breed);
      // console.log(
      //   `${cow.name} does ${result ? '' : 'not'} match selected breeds`
      // );
      return result;
    });
    // console.log('cowsMatchingBreed', filteredCows.length);
    return filteredCows;
  }
);
export const cowsMatchingInteractionFilter = createSelector(
  [cowsMatchingBreed, isFavourited, isInterested],
  (cows, favourited, interested) => {
    // console.log(favourited, interested);
    const filteredCows = cows.filter(cow => {
      // console.log(cow.name + ' ' + cow.favourite);
      if (favourited === true && cow.favourite !== true) {
        return false;
      } else if (interested === true && cow.interestRegistered !== true) {
        return false;
      }
      return true;
    });
    // console.log('cowsMatchingInteractionFilter', filteredCows.length);
    return filteredCows;
  }
);
export const getFilteredCows = createSelector(
  cowsMatchingInteractionFilter, cows => cows
);
export const countFilterMatch = createSelector(
  getFilteredCows, cows => cows.length
);
export const getSortedCows = createSelector(
  [getFilteredCows, getSortAttribute, getCowType], (cows, sort, type) => {
    const functions = type === 'FinishedCattle' ?
      finishedCattleSortFunctions : sortFunctions;
    return cows.slice().sort(functions[sort]);
  }
);
export const getPageOfCows = createSelector(
  [getCowPage, getCowPageSize, getSortedCows], (page, pageSize, cows) => {
    const start = (page - 1) * pageSize;
    const end = page * pageSize;
    return cows.slice(start, end);
  }
);
export const getPriceRange = createSelector(
  [getCowsMatchingType, getCowType], (cows, type) => {
    let match = { min: null, max: null };
    try {
      const index = type === 'FinishedCattle' ?
        cows[0].pricePerKilo / 100 : cows[0].price / 100;
      match = {
        min: Math.floor(index * 10) / 10,
        max: Math.ceil(index * 10) / 10
      };
      if (match.min === match.max) match.max += 1;
      // console.log(match);
    } catch (error) { /* */ }
    cows.forEach(cow => {
      const price = type === 'FinishedCattle' ?
        cow.pricePerKilo / 100 : cow.price / 100;
      if (!match.min || price < match.min) match.min = price;
      if (!match.max || price > match.max) match.max = price;
    });
    const adjustment = Math.round((match.max - match.min) / 10);
    match.min -= adjustment;
    match.max += adjustment;

    // if (match.min === null || match.max === null) {
    switch (type) {
      case 'YoungBulls':
        return { min: 2000, max: 4500 };
      case 'Heifers':
        return { min: 800, max: 4500 };
      case 'BreedingCows':
        return { min: 800, max: 4500 };
      case 'Semen':
        return { min: 10, max: 35 };
      case 'FinishedCattle':
        return { min: 3, max: 8 };
    }
    // }
    return match;
  }
);
export const getAgeRange = createSelector(
  [getCowsMatchingType, getCowType], (cows, type) => {
    let match = { min: 10, max: 14 };
    cows.forEach(cow => {
      if (!match.min || cow.age < match.min) match.min = cow.age;
      if (!match.max || cow.age > match.max) match.max = cow.age;
    });
    switch (type) {
      case 'YoungBulls':
        return { min: 12, max: 72 };
      case 'BreedingCows':
        return { min: 12, max: 120 };
      // case 'FinishedCattle':
      //   return { min: 13, max: 30 };
    }
    // console.log(match);
    const adjustment = Math.round((match.max - match.min) / 10);
    match.min -= adjustment;
    match.max += adjustment;
    return match;
  }
);
export const getScoreRange = createSelector(
  getCowsMatchingType, cows => {
    if (cows.length < 1 || !cows[0].beefQualityIndex) {
      return { min: 0, max: 120 };
    }
    const index = cows[0].beefQualityIndex;
    const match = {
      min: Math.floor(index / 10) * 10,
      max: Math.ceil(index / 10) * 10
    };
    // console.log('initial match', match);
    cows.forEach(cow => {
      if (!match.min || cow.beefQualityIndex < match.min) {
        match.min = Math.floor(cow.beefQualityIndex / 10) * 10;
      }
      if (!match.max || cow.beefQualityIndex > match.max) {
        match.max = Math.ceil(cow.beefQualityIndex / 10) * 10;
      }
    });
    // console.log('getScoreRange', match);
    return match;
    // return { min: 0, max: 120 };
  }
);
export const getScoreMin = createSelector(
  minScore, min => min
);
export const getScoreMax = createSelector(
  maxScore, max => max
);
export const getMinPrice = createSelector(
  [getPriceRange, minPrice], (range, minPrice) => {
    if (typeof minPrice === 'undefined' || minPrice === null) {
      if (typeof range.min === 'undefined' || range.min === null) {
        return 0;
      }
      return range.min;
    }
    if (typeof range.min === 'undefined' || range.min === null) {
      return minPrice;
    }
    if (minPrice < range.min) {
      return range.min;
    }
    return minPrice;
    // return minPrice < range.min ? range.min : (minPrice || 0);
  }
);
export const getMaxPrice = createSelector(
  [getPriceRange, maxPrice], (range, maxPrice) => {
    if (typeof maxPrice === 'undefined' || maxPrice === null) {
      if (typeof range.max === 'undefined' || range.max === null) {
        return 4500;
      }
      return range.max;
    }
    if (typeof range.max === 'undefined' || range.max === null) {
      return maxPrice;
    }
    if (maxPrice > range.max) {
      return range.max;
    }
    return maxPrice;
  }
);
export const getMinAge = createSelector(
  [getAgeRange, minAge], (range, minAge) => {
    return minAge < range.min ? range.min : (minAge || 0);
  }
);
export const getMaxAge = createSelector(
  [getAgeRange, maxAge], (range, maxAge) => {
    let max = maxAge > range.max ? range.max : (maxAge || 0);
    return max || range.max;
  }
);

export default reducer;
